export const CANDIDATE_INTAKE_DRAFT_KEY = 'jobmatchpro:candidate-intake-draft';
export const CANDIDATE_INTAKE_PREFILL_KEY = 'jobmatchpro:candidate-intake-prefill';
export const LEGACY_PHASE_1B_PREFILL_KEY = 'jobmatchpro:phase1b-prefill';

export const startingPaths = [
  'I know the type of role I want',
  'I know a few job titles',
  'I am open across a few areas',
  'I am not sure yet',
  'I am switching careers',
];

export const roleFamilies = [
  'Business, strategy, and operations',
  'Software, engineering, and IT',
  'Data, analytics, and AI',
  'Product, design, and user research',
  'Healthcare and clinical roles',
  'Life sciences and research',
  'Finance, accounting, and risk',
  'Sales, customer success, and growth',
  'People, HR, and talent',
  'Marketing and communications',
  'Legal, compliance, and policy',
  'Education, training, and social impact',
  'Not sure yet',
];

export const employmentTypeOptions = ['Internship', 'Working student', 'Apprenticeship', 'Graduate scheme', 'Permanent'];

export const roleDirectory = {
  'Business, strategy, and operations': {
    subFamilies: {
      'Business analysis': ['Business Analyst', 'Junior Business Analyst', 'Requirements Analyst'],
      'Strategy and consulting': ['Strategy Analyst', 'Junior Consultant', 'Transformation Analyst'],
      Operations: ['Operations Associate', 'Operations Analyst', 'Business Operations Associate'],
      'Project and programme coordination': ['Project Coordinator', 'Programme Assistant', 'PMO Analyst'],
      'Founder office and chief of staff': ['Founder Office Associate', 'Chief of Staff Associate'],
      'Supply chain and procurement': ['Supply Chain Analyst', 'Procurement Analyst'],
      'Customer operations': ['Customer Operations Associate', 'Customer Operations Analyst'],
    },
    defaultTitles: ['Business Analyst', 'Operations Associate', 'Project Coordinator', 'Strategy Analyst', 'Junior Consultant', 'Business Operations Associate', 'Founder Office Associate', 'Graduate Trainee'],
    searchOnly: ['Chief of Staff Associate', 'Transformation Analyst', 'Procurement Analyst', 'Management Trainee', 'Rotational Graduate Scheme', 'Business Intern'],
  },
  'Software, engineering, and IT': {
    subFamilies: {
      'Software Development': ['Software Engineer', 'Software Developer'],
      'Frontend Engineering': ['Frontend Developer', 'React Developer', 'Angular Developer', 'Vue Developer', 'UI Engineer'],
      'Backend Engineering': ['Backend Developer', 'Python Developer', 'Java Developer', 'Node.js Developer', 'API Developer'],
      'Full Stack Engineering': ['Full Stack Developer', 'Full Stack Engineer'],
      'Mobile Engineering': ['Mobile Developer', 'iOS Developer', 'Android Developer'],
      'QA and Testing': ['QA Engineer', 'Test Engineer', 'Automation QA Engineer'],
      'DevOps, Cloud, and Infrastructure': ['DevOps Engineer', 'Cloud Engineer', 'Infrastructure Engineer'],
      Cybersecurity: ['Cybersecurity Analyst', 'Security Engineer'],
      'IT Support and Systems': ['IT Support Analyst', 'Systems Administrator'],
      'Data Engineering': ['Data Engineer', 'Junior Data Engineer'],
      'Embedded, Hardware, and Electronics': ['Embedded Engineer', 'Hardware Engineer', 'Electronics Engineer'],
      'Robotics and Autonomous Systems': ['Robotics Engineer', 'Autonomous Systems Engineer'],
      'Game and Simulation': ['Game Developer', 'Simulation Engineer'],
      'Quantum and Deep Tech': ['Quantum Engineer'],
    },
    defaultTitles: ['Software Engineer', 'Frontend Developer', 'Backend Developer', 'Full Stack Developer', 'QA Engineer', 'DevOps Engineer', 'IT Support Analyst'],
    searchOnly: ['Quantum Software Engineer', 'Compiler Engineer', 'Photonics Engineer', 'SLAM Engineer', 'Kubernetes Engineer', 'Engineering Graduate Programme', 'Working Student', 'Summer Intern', 'Placement Student', 'Apprentice'],
  },
  'Data, analytics, and AI': {
    subFamilies: {
      'General AI and Machine Learning': ['Machine Learning Engineer', 'AI Engineer'],
      'Generative AI and LLMs': ['LLM Engineer', 'Generative AI Engineer', 'Prompt Engineer', 'AI Product Engineer'],
      'Natural Language Processing': ['NLP Engineer', 'Language AI Engineer'],
      'Computer Vision': ['Computer Vision Engineer', 'Vision AI Engineer', 'Image Processing Engineer'],
      'MLOps and AI Platform': ['MLOps Engineer', 'ML Platform Engineer', 'AI Platform Engineer'],
      'Data Science and Analytics': ['Data Analyst', 'Data Scientist', 'Analytics Engineer'],
      'Responsible AI, AI Safety, and Governance': ['AI Governance Analyst', 'Responsible AI Analyst'],
      'AI Product and Operations': ['AI Product Analyst', 'AI Operations Associate'],
    },
    defaultTitles: ['Data Analyst', 'BI Analyst', 'Data Scientist', 'Machine Learning Engineer', 'AI Engineer', 'Analytics Engineer', 'Product Analyst'],
    searchOnly: ['RAG Engineer', 'LLMOps Engineer', 'Agentic AI Engineer', 'Model Evaluation Engineer', 'AI Governance Analyst', 'Data Science Internship', 'Working Student', 'Summer Intern'],
  },
  'Product, design, and user research': {
    subFamilies: {
      'Product management': ['Associate Product Manager', 'Product Manager'],
      'Product analysis and product operations': ['Product Analyst', 'Product Operations Associate', 'Product Growth Analyst'],
      'UX/UI design': ['UX/UI Designer', 'UX Designer', 'UI Designer'],
      'User research': ['UX Researcher', 'User Researcher'],
      'Service design': ['Service Designer'],
      'Design systems': ['Design Systems Designer'],
      'Content design': ['Content Designer'],
    },
    defaultTitles: ['Associate Product Manager', 'Product Analyst', 'Product Operations Associate', 'UX/UI Designer', 'UX Researcher', 'Service Designer', 'Content Designer'],
    searchOnly: ['Design Systems Designer', 'UX Research Operations Coordinator', 'Product Growth Analyst'],
  },
  'Healthcare and clinical roles': {
    subFamilies: {
      'Nursing and clinical care': ['Healthcare Assistant', 'Nursing Assistant', 'Clinical Support Worker'],
      'Allied health': ['Occupational Therapy Assistant', 'Physiotherapy Assistant', 'Rehabilitation Assistant'],
      'Care and support work': ['Care Coordinator', 'Support Worker'],
      'Clinical administration': ['Clinical Administrator', 'Patient Coordinator', 'Medical Secretary'],
      'Mental health': ['Mental Health Support Worker'],
      Pharmacy: ['Pharmacy Assistant'],
      'Radiography and diagnostics': ['Diagnostics Assistant'],
      'Digital health': ['Digital Health Associate'],
    },
    defaultTitles: ['Healthcare Assistant', 'Clinical Support Worker', 'Care Coordinator', 'Nursing Assistant', 'Occupational Therapy Assistant', 'Physiotherapy Assistant', 'Mental Health Support Worker'],
    searchOnly: ['Radiographer', 'Pharmacist', 'Registered Nurse', 'Clinical Research Nurse'],
  },
  'Life sciences and research': {
    subFamilies: {
      'Laboratory science': ['Lab Technician', 'Laboratory Assistant'],
      'Clinical research': ['Clinical Research Coordinator', 'Research Assistant'],
      'Regulatory affairs': ['Regulatory Affairs Associate'],
      'Quality assurance': ['Quality Assurance Associate'],
      'Medical writing': ['Medical Writer'],
      'Biomedical research': ['Biomedical Research Assistant'],
      'Research operations': ['Research Operations Associate'],
    },
    defaultTitles: ['Research Assistant', 'Lab Technician', 'Clinical Research Coordinator', 'Regulatory Affairs Associate', 'Quality Assurance Associate', 'Medical Writer'],
    searchOnly: ['Biomedical Scientist', 'GCP Specialist', 'Pharmacovigilance Associate'],
  },
  'Finance, accounting, and risk': {
    subFamilies: {
      Accounting: ['Accounting Assistant', 'Junior Accountant'],
      Audit: ['Audit Associate', 'Audit Assistant'],
      'Financial analysis': ['Finance Analyst', 'Financial Analyst'],
      'FP&A': ['FP&A Analyst'],
      'Investment and markets': ['Investment Analyst'],
      Risk: ['Risk Analyst'],
      Compliance: ['Compliance Analyst'],
      Treasury: ['Treasury Analyst'],
      Tax: ['Tax Associate'],
    },
    defaultTitles: ['Finance Analyst', 'Accounting Assistant', 'Audit Associate', 'Risk Analyst', 'Compliance Analyst', 'Investment Analyst', 'FP&A Analyst'],
    searchOnly: ['Treasury Analyst', 'Tax Associate', 'Model Risk Analyst', 'Finance Graduate Scheme'],
  },
  'Sales, customer success, and growth': {
    subFamilies: {
      'Sales development': ['Sales Development Representative'],
      'Account executive': ['Account Executive'],
      'Customer success': ['Customer Success Associate', 'Customer Onboarding Specialist'],
      'Account management': ['Account Manager'],
      Partnerships: ['Partnerships Associate'],
      'Revenue operations': ['Revenue Operations Analyst', 'Sales Operations Analyst'],
      'Growth operations': ['Growth Associate'],
    },
    defaultTitles: ['Sales Development Representative', 'Account Executive', 'Customer Success Associate', 'Account Manager', 'Partnerships Associate', 'Revenue Operations Analyst', 'Growth Associate'],
    searchOnly: ['Sales Operations Analyst', 'Customer Onboarding Specialist'],
  },
  'People, HR, and talent': {
    subFamilies: {
      'HR operations': ['HR Assistant', 'HR Operations Associate'],
      'Talent acquisition': ['Talent Acquisition Associate', 'Recruitment Coordinator'],
      'People operations': ['People Operations Associate'],
      'Learning and development': ['Learning and Development Assistant'],
      'HR analytics': ['HR Analyst', 'People Data Analyst'],
      'Employee experience': ['Employee Experience Coordinator'],
    },
    defaultTitles: ['HR Assistant', 'Talent Acquisition Associate', 'People Operations Associate', 'Learning and Development Assistant', 'HR Analyst', 'Employee Experience Coordinator'],
    searchOnly: ['Recruitment Coordinator', 'People Data Analyst'],
  },
  'Marketing and communications': {
    subFamilies: {
      'Growth marketing': ['Growth Marketing Associate'],
      'Performance marketing': ['Performance Marketing Analyst'],
      'Content marketing': ['Content Associate', 'Content Marketing Associate'],
      'Social media': ['Social Media Manager', 'Social Media Specialist'],
      Brand: ['Brand Associate'],
      Communications: ['Communications Associate', 'Communications Assistant'],
      'Product marketing': ['Product Marketing Associate'],
      'Marketing operations': ['Marketing Operations Analyst'],
    },
    defaultTitles: ['Marketing Associate', 'Marketing Coordinator', 'Content Associate', 'Social Media Manager', 'Brand Associate', 'Communications Associate', 'Performance Marketing Analyst'],
    searchOnly: ['Lifecycle Marketing Associate', 'SEO Specialist', 'Marketing Operations Analyst'],
  },
  'Legal, compliance, and policy': {
    subFamilies: {
      'Legal operations': ['Legal Operations Assistant'],
      'Legal assistant and paralegal': ['Legal Assistant', 'Paralegal'],
      Compliance: ['Compliance Associate', 'Regulatory Compliance Analyst'],
      'Data protection and privacy': ['Data Protection Associate', 'Privacy Analyst'],
      Policy: ['Policy Analyst'],
      Contracts: ['Contract Analyst'],
      Governance: ['Governance Analyst'],
    },
    defaultTitles: ['Legal Assistant', 'Paralegal', 'Compliance Associate', 'Policy Analyst', 'Data Protection Associate', 'Contract Analyst'],
    searchOnly: ['Privacy Analyst', 'Governance Analyst', 'Regulatory Compliance Analyst'],
  },
  'Education, training, and social impact': {
    subFamilies: {
      'Teaching support': ['Teaching Assistant'],
      'Training coordination': ['Training Coordinator'],
      'Programme coordination': ['Programme Coordinator', 'Education Programme Assistant'],
      'NGO operations': ['NGO Operations Associate'],
      'Community and social impact': ['Community Manager', 'Social Impact Analyst'],
      'Education technology': ['Learning Designer'],
    },
    defaultTitles: ['Teaching Assistant', 'Programme Coordinator', 'Training Coordinator', 'NGO Operations Associate', 'Community Manager', 'Education Programme Assistant'],
    searchOnly: ['Learning Designer', 'Social Impact Analyst'],
  },
  'Not sure yet': {
    subFamilies: {},
    defaultTitles: ['Graduate Trainee', 'Project Coordinator', 'Operations Associate', 'Data Analyst', 'Marketing Coordinator', 'Customer Success Associate'],
    searchOnly: ['Working Student', 'Summer Intern', 'Placement Student', 'Apprentice', 'Management Trainee', 'Rotational Graduate Scheme'],
  },
};

export const earlyCareerTitleSuggestions = {
  Internship: ['Summer Intern', 'Business Intern', 'Data Science Internship', 'Placement Student'],
  'Working student': ['Working Student'],
  Apprenticeship: ['Apprentice'],
  'Graduate scheme': ['Graduate Trainee', 'Management Trainee', 'Rotational Graduate Scheme', 'Finance Graduate Scheme', 'Engineering Graduate Programme'],
  Permanent: [],
};

export const seniorityLevels = ['Entry-level', 'Junior', 'Associate', 'Mid-level', 'Senior', 'Lead', 'Manager', 'Not sure yet'];
export const searchMarkets = ['Germany', 'London / UK', 'Remote Europe', 'Not sure yet'];
export const workSetupOptions = ['Remote', 'Hybrid', 'On-site', 'Not sure yet'];

export const workTypeOptions = [
  'Solving unclear or complex problems',
  'Analysing data and making recommendations',
  'Planning and delivering projects',
  'Improving processes and operations',
  'Building products, systems or services',
  'Working with customers or clients',
  'Coordinating across teams',
  'Researching and building expertise',
  'Managing or supporting people',
  'Shaping strategy and direction',
  'Not sure yet',
];

export const motivationOptions = [
  'Learning and development',
  'Career progression',
  'Pay and benefits',
  'Job stability',
  'Flexible working',
  'Support and mentorship',
  'Interesting problems',
  'Purpose or mission',
  'Work-life balance',
];

export const waysOfWorkingOptions = [
  'With clear goals and freedom over how I deliver',
  'With regular guidance and feedback',
  'Owning my own area independently',
  'Closely with one team',
  'Across different teams and functions',
  'Directly with customers or clients',
  'In a structured, process-driven setting',
  'In a fast-changing setting',
  'No strong preference',
];

export const reasonForLookingOptions = [
  'Looking for more responsibility',
  'Changing career direction',
  'Seeking better progression',
  'Relocating',
  'Returning to work',
  'Finishing my studies',
  'My current role or contract is ending',
  'Looking for more flexibility',
  'Exploring stronger opportunities',
  'Prefer not to say',
];

export const availabilityOptions = [
  'Immediately',
  'Within 1 month',
  '1 to 3 months',
  'More than 3 months',
  'Not sure yet',
];

export const noticePeriodOptions = [
  'None',
  '2 weeks',
  '1 month',
  '2 months',
  '3 months or more',
];

export const thingsToAvoidOptions = [
  'Cold calling or heavy sales targets',
  'Frequent travel',
  'Shift or weekend work',
  'Highly repetitive tasks',
  'Constant client interaction',
  'Very unstructured environments',
  'Heavy people management',
  'Long or unpredictable hours',
  'Nothing to avoid',
];

const supportedMarkets = new Set(['Germany', 'London / UK', 'Remote Europe']);

export function createCandidateIntakeDraft(overrides = {}) {
  const base = {
    careerAgent: {
      startingPath: '',
      roleFamilies: [],
      subFamilies: [],
      targetTitles: [],
      primaryLevel: '',
      nearbyLevels: [],
      employmentTypes: [],
      targetMarkets: [],
      openToRelocateEurope: false,
      workSetup: [],
      workTypes: [],
      motivations: [],
    },
    searchPreferences: {
      targetRoles: [],
      targetLocations: [],
      seniorityLevels: [],
      currentJobTitle: '',
      currentLocation: '',
      yearsExperience: '',
      salaryExpectation: '',
      salaryFloor: { amount: '', currency: '', period: '' },
      salaryFloorsByMarket: {},
      visaStatus: '',
      germanLevel: '',
      otherLanguages: [],
      skills: [],
      education: '',
      educationStatus: '',
    },
    cvEvidence: {
      contact: {},
      summary: '',
      experience: [],
      education: [],
      projects: [],
      skills: [],
      certifications: [],
      languages: [],
      rawText: '',
      extractionStatus: '',
    },
    candidateInsights: {
      reasonForLooking: '',
      availability: '',
      noticePeriod: '',
      waysOfWorking: [],
      thingsToAvoid: [],
      firmNoItems: [],
    },
    userEdits: {},
  };
  return {
    ...base,
    ...overrides,
    careerAgent: { ...base.careerAgent, ...(overrides.careerAgent || {}) },
    searchPreferences: { ...base.searchPreferences, ...(overrides.searchPreferences || {}) },
    cvEvidence: { ...base.cvEvidence, ...(overrides.cvEvidence || {}) },
    candidateInsights: { ...base.candidateInsights, ...(overrides.candidateInsights || {}) },
    userEdits: { ...base.userEdits, ...(overrides.userEdits || {}) },
  };
}

export function uniqueArray(values) {
  const seen = new Set();
  return (Array.isArray(values) ? values : [])
    .map((value) => String(value || '').trim())
    .filter(Boolean)
    .filter((value) => {
      const key = value.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}

export function splitList(value) {
  if (Array.isArray(value)) return uniqueArray(value);
  return uniqueArray(String(value || '').split(/[;,\n•]+/));
}

export function joinList(values) {
  return uniqueArray(values).join(', ');
}

export function toggleArrayValue(values, value) {
  const current = uniqueArray(values);
  return current.some((item) => item.toLowerCase() === String(value).toLowerCase())
    ? current.filter((item) => item.toLowerCase() !== String(value).toLowerCase())
    : [...current, value];
}

export function addArrayValue(values, value) {
  return uniqueArray([...uniqueArray(values), value]);
}

export function toggleExclusiveArrayValue(values, value, exclusiveValue = 'Not sure yet') {
  const clean = String(value || '').trim();
  if (!clean) return uniqueArray(values);
  if (clean === exclusiveValue) {
    return uniqueArray(values).includes(exclusiveValue) ? [] : [exclusiveValue];
  }
  return toggleArrayValue(uniqueArray(values).filter((item) => item !== exclusiveValue), clean);
}

export function mapSeniorityToExistingLabel(level) {
  const map = {
    'Entry-level': 'Entry Level / Junior',
    Junior: 'Entry Level / Junior',
    Associate: 'Associate / Consultant',
    'Mid-level': 'Mid-Level',
    Senior: 'Senior',
    Lead: 'Manager / Lead',
    Manager: 'Manager / Lead',
  };
  return map[level] || '';
}

export function suggestedNearbyLevels(primaryLevel) {
  const map = {
    'Entry-level': ['Junior'],
    Junior: ['Entry-level', 'Associate'],
    Associate: ['Junior', 'Mid-level'],
    'Mid-level': ['Associate', 'Senior'],
    Senior: ['Mid-level', 'Lead'],
    Lead: ['Senior', 'Manager'],
    Manager: ['Lead', 'Senior'],
  };
  return map[primaryLevel] || [];
}

export function syncSearchPreferencesFromCareerAgent(draft) {
  const normalized = createCandidateIntakeDraft(draft);
  const agent = normalized.careerAgent;
  const seniority = uniqueArray([agent.primaryLevel, ...agent.nearbyLevels])
    .map(mapSeniorityToExistingLabel)
    .filter(Boolean);
  return createCandidateIntakeDraft({
    ...normalized,
    careerAgent: {
      ...agent,
      roleFamilies: uniqueArray(agent.roleFamilies),
      subFamilies: uniqueArray(agent.subFamilies),
      targetTitles: uniqueArray(agent.targetTitles),
      nearbyLevels: uniqueArray(agent.nearbyLevels),
      employmentTypes: uniqueArray(agent.employmentTypes),
      targetMarkets: uniqueArray(agent.targetMarkets),
      openToRelocateEurope: Boolean(agent.openToRelocateEurope),
      workSetup: uniqueArray(agent.workSetup),
      workTypes: uniqueArray(agent.workTypes),
      motivations: uniqueArray(agent.motivations),
    },
    searchPreferences: {
      ...normalized.searchPreferences,
      targetRoles: uniqueArray(agent.targetTitles),
      targetLocations: uniqueArray(agent.targetMarkets).filter((market) => supportedMarkets.has(market)),
      seniorityLevels: uniqueArray(seniority),
    },
  });
}

export function buildCandidateIntakePrefill(draft) {
  const normalized = syncSearchPreferencesFromCareerAgent(draft);
  const mapped = {
    target_roles: joinList(normalized.searchPreferences.targetRoles),
    target_roles_list: normalized.searchPreferences.targetRoles,
    target_locations: joinList(normalized.searchPreferences.targetLocations),
    target_locations_list: normalized.searchPreferences.targetLocations,
    target_seniority: normalized.searchPreferences.seniorityLevels[0] || '',
    target_seniority_levels: normalized.searchPreferences.seniorityLevels,
  };
  return {
    schema_version: 'candidate-intake-draft-v1',
    saved_at: new Date().toISOString(),
    candidateIntakeDraft: normalized,
    mapped,
  };
}

export function parseCandidateIntakePrefill(value) {
  const source = value && typeof value === 'object' ? value : {};
  if (source.candidateIntakeDraft) {
    const draft = syncSearchPreferencesFromCareerAgent(source.candidateIntakeDraft);
    const mapped = source.mapped || buildCandidateIntakePrefill(draft).mapped;
    return { candidateIntakeDraft: draft, mapped };
  }
  const legacyDraft = syncSearchPreferencesFromCareerAgent(createCandidateIntakeDraft({
    careerAgent: {
      targetTitles: splitList(source.target_roles || source.target_roles_list),
      targetMarkets: splitList(source.target_locations || source.target_locations_list),
    },
    searchPreferences: {
      targetRoles: splitList(source.target_roles || source.target_roles_list),
      targetLocations: splitList(source.target_locations || source.target_locations_list),
      seniorityLevels: splitList(source.target_seniority_levels || source.target_seniority),
    },
  }));
  return {
    candidateIntakeDraft: legacyDraft,
    mapped: {
      target_roles: joinList(legacyDraft.searchPreferences.targetRoles),
      target_roles_list: legacyDraft.searchPreferences.targetRoles,
      target_locations: joinList(legacyDraft.searchPreferences.targetLocations),
      target_locations_list: legacyDraft.searchPreferences.targetLocations,
      target_seniority: Array.isArray(source.target_seniority_levels) ? source.target_seniority_levels[0] || '' : source.target_seniority || '',
      target_seniority_levels: splitList(source.target_seniority_levels || source.target_seniority),
    },
  };
}

export function availableSubFamilies(selectedFamilies) {
  return uniqueArray(selectedFamilies).flatMap((family) => Object.keys(roleDirectory[family]?.subFamilies || {}));
}

export function allKnownTitles() {
  return uniqueArray(Object.values(roleDirectory).flatMap((family) => [
    ...family.defaultTitles,
    ...family.searchOnly,
    ...Object.values(family.subFamilies || {}).flat(),
  ]));
}

export function titleSuggestionsForDraft(draft, query = '') {
  const agent = draft.careerAgent || {};
  const families = agent.roleFamilies?.length ? agent.roleFamilies : ['Not sure yet'];
  const subFamilies = uniqueArray(agent.subFamilies || []);
  const selected = uniqueArray(agent.targetTitles || []);
  let titles = [];
  families.forEach((family) => {
    const config = roleDirectory[family] || roleDirectory['Not sure yet'];
    if (subFamilies.length) {
      subFamilies.forEach((subFamily) => {
        titles.push(...(config.subFamilies?.[subFamily] || []));
      });
    }
    titles.push(...(config.defaultTitles || []));
  });
  uniqueArray(agent.employmentTypes || []).forEach((type) => {
    titles.push(...(earlyCareerTitleSuggestions[type] || []));
  });
  const q = String(query || '').trim().toLowerCase();
  if (q) {
    titles = allKnownTitles().filter((title) => title.toLowerCase().includes(q));
  }
  return uniqueArray(titles).filter((title) => !selected.some((item) => item.toLowerCase() === title.toLowerCase())).slice(0, 12);
}